"use strict";

exports.__esModule = true;
exports.default = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgNavMenuActive(props) {
  return (0, _jsxRuntime.jsxs)("svg", _extends({
    width: 66,
    height: 34,
    viewBox: "0 0 66 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [(0, _jsxRuntime.jsx)("path", {
      transform: "rotate(180 66 34)",
      fill: "url(#prefix__paint0_diamond)",
      d: "M66 34h66v15H66z"
    }), (0, _jsxRuntime.jsx)("path", {
      transform: "rotate(180 66 34)",
      fill: "url(#prefix__paint1_diamond)",
      d: "M66 34h66v15H66z"
    }), (0, _jsxRuntime.jsx)("g", {
      filter: "url(#prefix__filter0_d)",
      children: (0, _jsxRuntime.jsx)("path", {
        d: "M33 24l5.196 9H27.804L33 24z",
        fill: "#B2D530"
      })
    }), (0, _jsxRuntime.jsxs)("defs", {
      children: [(0, _jsxRuntime.jsxs)("radialGradient", {
        id: "prefix__paint0_diamond",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(0 11.25 -28.0656 0 99 35.406)",
        children: [(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#B2D530"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: 1,
          stopColor: "#0A2133",
          stopOpacity: 0
        })]
      }), (0, _jsxRuntime.jsxs)("radialGradient", {
        id: "prefix__paint1_diamond",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(0 3.75 -25.8343 0 99 34)",
        children: [(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#DBF1C1"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: 1,
          stopColor: "#B2D530",
          stopOpacity: 0
        })]
      }), (0, _jsxRuntime.jsxs)("filter", {
        id: "prefix__filter0_d",
        x: 3.804,
        y: 0,
        width: 58.392,
        height: 57,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [(0, _jsxRuntime.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), (0, _jsxRuntime.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), (0, _jsxRuntime.jsx)("feOffset", {}), (0, _jsxRuntime.jsx)("feGaussianBlur", {
          stdDeviation: 12
        }), (0, _jsxRuntime.jsx)("feColorMatrix", {
          values: "0 0 0 0 0.698039 0 0 0 0 0.835294 0 0 0 0 0.188235 0 0 0 0.7 0"
        }), (0, _jsxRuntime.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), (0, _jsxRuntime.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow",
          result: "shape"
        })]
      })]
    })]
  }));
}
var _default = SvgNavMenuActive;
exports.default = _default;